module.exports = __webpack_public_path__ + "static/media/1898Sans-Regular.907eda88.otf";